import type { PreTradeResponseData } from './redux/preTradeApi';

export const PreTradeTabType = {
  History: 'history',
  Scenarios: 'scenarios',
  Details: 'details',
} as const;
export type PreTradeTabType = (typeof PreTradeTabType)[keyof typeof PreTradeTabType];

export interface PreTradeRouteState {
  openTab?: PreTradeTabType;
  requestId?: string;
}

/** requestId is only meaningful on the details tab; strip it everywhere else. */
export function resolvePreTradeRequestId(tab: PreTradeTabType | undefined, requestId: string | undefined) {
  return tab === PreTradeTabType.Details ? requestId : undefined;
}

export interface OpenScenario {
  scenario: PreTradeResponseData;
  originalIndex: number;
}

export interface TotalCostRiskData {
  spreadCost: number;
  tempCost: number;
  risk: number;
  total: number;
}

export interface TradePredictionData {
  startTime: Date;
  endTime: Date;
  spread: { interval: number; daily: number };
  volume: { interval: number; daily: number };
  participationRate: { interval: number; daily: number };
  volatility: { interval: number; daily: number };
  duration: { interval: string; daily: string };
}

export interface PublicMarketsNumericFields {
  volumeHorizon: number | null;
  adv: number | null;
  advPct: number | null;
  spread: number | null;
  spreadDaily: number | null;
  volatility: number | null;
  volatilityDaily: number | null;
}

export interface PublicMarketRowData extends PublicMarketsNumericFields {
  marketName: string;
}
